import { Component, ViewEncapsulation  } from '@angular/core';
import PopupHelper from '../models/popupHelper';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [
    '../../node_modules/normalize.css/normalize.css',
    './app.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  title = 'CRIM Web Application';

  showTeamEasterEgg() {
    PopupHelper.developerEasterEgg();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts